import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const assignComplaint = createAction(ACTION.COMPLAINT_ASSIGN.REQUEST, params => ({params}));
export const clearState = createAction(ACTION.CLEAR_STATE, id => ({id}));
